module.exports = __webpack_public_path__ + "static/media/more-rafa.371a06a7.png";